module.exports = __webpack_public_path__ + "media/images/common/menu_hat_ov-57908bbb0bf0263dc5a2dccb7fbb6a8c.gif";